var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeColored = function SvgYoutubeColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.61.541C13.73.323 7.304.323 4.423.541 1.301.777.932 2.824.909 8.227c.024 5.385.384 7.45 3.505 7.685 2.881.218 9.308.218 12.189 0 3.121-.235 3.49-2.283 3.513-7.685-.024-5.385-.384-7.45-3.505-7.686ZM8.112 11.712v-6.97l6.403 3.476-6.403 3.494Z",
    fill: "#5D5BEA"
  })));
};
export default SvgYoutubeColored;